import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [bank, setBank] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("acas_token");
    const cachedUser = localStorage.getItem("acas_user");
    const cachedBank = localStorage.getItem("acas_bank");
    if (token && cachedUser) {
      try {
        setUser(JSON.parse(cachedUser));
        if (cachedBank) setBank(JSON.parse(cachedBank));
      } catch (e) {
        // ignore
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    const { token, user, bank } = res.data;
    localStorage.setItem("acas_token", token);
    localStorage.setItem("acas_user", JSON.stringify(user));
    if (bank) localStorage.setItem("acas_bank", JSON.stringify(bank));
    else localStorage.removeItem("acas_bank");
    // Trigger one-shot welcome popup after successful login
    sessionStorage.setItem("acas_show_welcome", "1");
    setUser(user);
    setBank(bank);
    return user;
  };

  const logout = () => {
    localStorage.removeItem("acas_token");
    localStorage.removeItem("acas_user");
    localStorage.removeItem("acas_bank");
    setUser(null);
    setBank(null);
    window.location.href = "/login";
  };

  const refreshAuth = async () => {
    try {
      const r = await api.get("/auth/me");
      if (r.data?.id || r.data?.sub) {
        const u = r.data;
        localStorage.setItem("acas_user", JSON.stringify(u));
        setUser(u);
      }
    } catch (e) {
      // ignore — token may have expired
    }
  };

  return (
    <AuthCtx.Provider value={{ user, bank, loading, login, logout, refreshAuth }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
